import { useQuery } from '@tanstack/react-query';

export type FeatureFlagStatus = 'fully_released' | 'partially_released' | 'disabled';

export type FeatureFlagResponse = {
  key: string;
  name: string;
  status: FeatureFlagStatus;
  maintainer: string | null;
};

type FlagEvaluationResponse = {
  key: string;
  value: boolean;
};

export const useFlagEvaluations = (tenantName: string | null) => {
  const { data, isLoading, isError } = useQuery<FlagEvaluationResponse[]>({
    queryKey: ['admin', 'feature-flags', 'evaluate', tenantName],
    enabled: tenantName !== null,
  });

  return {
    evaluations: data,
    isLoading,
    isError,
  };
};

export const useAdminFeatureFlags = () => {
  const { data, isLoading, isError, error, refetch, isRefetching } = useQuery<
    FeatureFlagResponse[]
  >({
    queryKey: ['admin', 'feature-flags'],
  });

  return {
    flags: data,
    isLoading,
    isError,
    error,
    refetch,
    isRefetching,
  };
};
